import { List, Record } from 'immutable';
export * from 'immutable';
export var RecordOf = Record;
export var EmptyListOf = function EmptyListOf(record) {
  return List();
};
export var findById = function findById(list, id) {
  return list.find(function (d) {
    return d.id === id;
  });
};
export var mergeListsById = function mergeListsById(a, b) {
  return a.filter(function (ar) {
    return !b.find(function (br) {
      return br.id === ar.id;
    });
  }).concat(b);
};